export default "__VITE_ASSET__Bg$SL48J__"